"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.startReportCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var logger_1 = require("../../logger");
var LogStatusForReport = (_a = {},
    _a[browser_core_1.RawReportType.cspViolation] = logger_1.StatusType.error,
    _a[browser_core_1.RawReportType.intervention] = logger_1.StatusType.error,
    _a[browser_core_1.RawReportType.deprecation] = logger_1.StatusType.warn,
    _a);
function startReportCollection(configuration, sender) {
    var reportObservable = (0, browser_core_1.initReportObservable)(configuration.forwardReports);
    var reportSubscription = reportObservable.subscribe(logReport);
    function logReport(report) {
        var message = report.message;
        var messageContext = {
            origin: browser_core_1.ErrorSource.REPORT,
        };
        var logStatus = LogStatusForReport[report.type];
        if (logStatus === logger_1.StatusType.error) {
            messageContext.error = {
                kind: report.subtype,
                origin: browser_core_1.ErrorSource.REPORT,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0, browser_core_1.getFileFromStackTraceString)(report.stack));
        }
        sender.sendToHttp(message, messageContext, logStatus);
    }
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
exports.startReportCollection = startReportCollection;
//# sourceMappingURL=reportCollection.js.map